import Pending from './pending';
import PendingSmall from './pending_small';
import Success from './success';
import SuccessSmall from './success_small';
import Warning from './warning';
import WarningSmall from './warning_small';

export default {
    Pending,
    PendingSmall,
    Success,
    SuccessSmall,
    Warning,
    WarningSmall
}